import React from 'react';

import { parseWhatsappFormatting, WhatsappNode, WhatsappStyle } from './whatsappFormatting';

const STYLE_TAGS: Record<WhatsappStyle, 'strong' | 'em' | 's' | 'code'> = {
  bold: 'strong',
  italic: 'em',
  strike: 's',
  code: 'code',
};

/**
 * Rend la mise en forme WhatsApp en elements React (jamais de HTML injecte).
 * `renderPlain` rend chaque morceau de texte brut (mentions, liens...).
 */
export function renderWhatsappFormatting(
  text: string,
  renderPlain: (plain: string) => React.ReactNode
): React.ReactNode {
  const nodes = parseWhatsappFormatting(text);

  // Sans mise en forme, rendu strictement identique a avant.
  if (nodes.every(node => typeof node === 'string')) return renderPlain(text);

  const render = (children: WhatsappNode[]): React.ReactNode[] =>
    children.map((node, i) =>
      typeof node === 'string' ? (
        <React.Fragment key={i}>{renderPlain(node)}</React.Fragment>
      ) : (
        React.createElement(STYLE_TAGS[node.style], { key: i }, render(node.children))
      )
    );

  return <>{render(nodes)}</>;
}
